
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.016 5.523c0 .961-1.54.961-1.54 0 0-.964 1.544-.964 1.544 0zm5.609.707h1.512l-.774-1.418zm-8.79 3.293c-1.456 0-2.585 1.098-2.585 2.395s1.129 2.395 2.586 2.395h12.086a.452.452 0 010 .902H4.836c-1.899 0-3.484-1.45-3.484-3.297 0-1.848 1.585-3.297 3.484-3.297h12.082c1.043 0 1.988.434 2.629 1.133a.45.45 0 01-.027.637.446.446 0 01-.633-.028 2.67 2.67 0 00-1.969-.84zm2.817 2.395c0 1.078-1.722 1.078-1.722 0 0-1.074 1.722-1.074 1.722 0zm4.082 0c0 1.078-1.722 1.078-1.722 0 0-1.074 1.722-1.074 1.722 0zm3.946 0c0 1.078-1.727 1.078-1.727 0 0-1.074 1.727-1.074 1.727 0zm-5.621-7.105h1.511V6.23H10.06zm5.066 14.21h-1.512l.739-1.418zm-7.129-1.418H6.484v1.418h1.512zm3.578.711c0 .961-1.539.961-1.539 0 0-.964 1.54-.964 1.54 0zm10.996-7.925l.715.648a.33.33 0 01.004.496l-2.965 2.785a.92.92 0 01-.629.242.93.93 0 01-.617-.23l-1.71-1.555a.332.332 0 01-.005-.496l.703-.66a.422.422 0 01.27-.105h.004c.098 0 .195.035.265.101l1.082.98 2.344-2.202a.395.395 0 01.27-.106c.101 0 .199.035.27.102zm0 0"}})])
          )
        }
      }
    